<svelte:options
  customElement={{
    tag: 'teo-assistant',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import AssistantComponent from '@/ui/components/assistant/AssistantComponent.svelte';
  import { TeoActiveTextProvider, TeoProvider } from '@/utils/teo-context';

  import type { TeoCore } from '../teoCore/TeoCore';
  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <TeoActiveTextProvider {teoCore}>
    {#snippet children({ teoText })}
      <AssistantComponent {teoText} />
    {/snippet}
  </TeoActiveTextProvider>
</TeoProvider>
